import { ReactComponent as Cross } from '../assets/cross.svg';
import Spinner from '../share/Spinner';
import { Link, useLocation } from 'react-router-dom';
import { MissionCalendar } from './manage/member-detail/MissionCalendar';
import { Chatroom } from '../models';
import { useContext, useState } from 'react';
import { useTaskResult } from './UseTaskResult';
import LIFFUserContext from '../contexts/LIFFUserContext';
import { CustomerProfile } from '../models/customerProfile';
import background from '../assets/manage-bg.svg';
import { getExactDate } from '../utils';
import { FeedbackCard } from './manage/member-detail/FeedbackCard';
import { useTranslation } from 'react-i18next';
import { UserRole } from '../models/userRole';

function MyAnswer({ room }: { room: Chatroom }) {
  const [t] = useTranslation(['chatroom']);
  document.title = t('activity_record', '活動紀錄');
  const user = useContext(LIFFUserContext) as CustomerProfile;
  const [selectedDay, setSelectedDay] = useState(
    Math.min(room.activity.duration, room.activity.day)
  );

  const [taskResult] = useTaskResult(user.userId, room, selectedDay);
  const style = {
    backgroundImage: `url(${background})`,
  };

  return (
    <div className="relative">
      <nav className="sticky top-0 z-50 bg-manage-primary text-white h-12 flex justify-between items-center px-2.5 py-4 text-xl">
        <span>{room.name}</span>
        <Link to={'/chatrooms'}>
          <div className="py-5 flex items-center gap-2.5">
            <Cross />
          </div>
        </Link>
      </nav>

      <div className="h-[calc(100vh_-_3rem)] flex flex-col">
        <div className="bg-manage-primary px-5 py-2">
          <MissionCalendar
            duration={room.activity.duration!}
            today={room.activity.day}
            selectedDay={selectedDay}
            updateCurrentDay={setSelectedDay}
          />
        </div>
        <div
          style={style}
          className="flex-grow bg-no-repeat bg-cover px-4 py-6 overflow-y-scroll"
        >
          <div className="flex flex-col gap-4">
            <div className="flex flex-row items-start justify-between">
              <div className="flex flex-row items-center">
                <span className="font-bold text-2xl text-manage-primary mr-2">
                  {t('activity_record_day', '第 {{selectedDay}} 天', {
                    selectedDay: selectedDay,
                  })}
                </span>
                <span>({getExactDate(selectedDay, room.activity.day)})</span>
              </div>
              {
                // Only Partner, Member & customer can access MyAnswerContianer.
                // Only Partner has the right to view child group here.
                room.role === UserRole.PARTNER && (
                  <Link
                    to={`/chatrooms/${room.id}/child`}
                    className="self-end font-medium border border-group-sub bg-opacity-30 bg-group-sub p-2 mt-4 rounded text-center"
                  >
                    {t('activity_dashboard_view_child_group', '檢視子群組')}
                  </Link>
                )
              }
            </div>
            {taskResult.map((data) => (
              <FeedbackCard key={data.id} taskData={data} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default function MyAnswerContainer() {
  const { state } = useLocation() as { state: { room: Chatroom } };

  if (!state || !state.room) {
    return <Spinner />;
  }

  return <MyAnswer room={state.room} />;
}
